import { router }       from './router/router'
import store            from './store'
import Vue              from 'vue/dist/vue.min.js';
import VueHead          from 'vue-head'
import {SERVER_PATH}    from './config.js'
import {apiDomain}      from './config.js'
import {Carousel3d}     from 'vue-carousel-3d'
import VueAnimateNumber from 'vue-animate-number'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import VueDragscroll    from "vue-dragscroll";
import analytics        from './services/analytics'

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
import VueMeta from 'vue-meta'
Vue.use(VueMeta)
Vue.use(VueDragscroll);

Vue.use(VueAnimateNumber)
Vue.use(VueHead)
Vue.use(Carousel3d)
Vue.config.productionTip = false;
Vue.config.devtools = false;


new Vue({
  SERVER_PATH,
  apiDomain,
  store,
  router,
}).$mount('#app')

// Audience analytics: registers the session, page views, heartbeats and
// lifecycle hooks. Best-effort — failures never affect the app.
analytics.init(router)

      // Functions

// Close enlarged image by clicking outside of the window
// Vue.directive('click-outside', {
//   bind: function (el, binding, vnode) {
//       window.event = function (event) {
//           if (!(el == event.target || el.contains(event.target))) {
//               vnode.context[binding.expression](event);
//           }
//       };
//       document.body.addEventListener('click', window.event)
//   },
//   unbind: function () {
//       document.body.removeEventListener('click', window.event)
//   },
// });


